<script>
    import Button from 'views/components/button/Button.svelte';
    import ContentLabel from 'views/components/contentLabel/ContentLabel.svelte';
    import Icon from 'views/components/icon/Icon.svelte';
    import {getAttainableTestScoreForSection, getEntryTestSections, getScoreForSection} from 'util/activityUtil/EntryTestUtil'
    import UnfinishedTasksCard from 'views/pages/activities/show/types/exam/summary/UnfinishedTasksCard.svelte';

    const {
        isStart,
        model,
        isStudentExamMode,
        isStudentExamClosedMode,
        isStudentReviewAnswersMode,
        navigationBar,
    } = $props()

    // svelte-ignore state_referenced_locally
    const unfinishedTasks = model.getUnfinishedTasks()

    function gotoParentSection() {
        Backbone.history.navigate(`/sections/show/${model.get('section_id')}`, {trigger: true})
    }

    function handInTest() {
        Backbone.View.layout.openConfirmStatus(
            window.i18n.sprintf(window.i18n.gettext(
                'If you hand in this %s you can no longer edit your answers. Are you sure you\'re finished?'
            ), model.getActivityTypeLabel().toLowerCase()),
            () => model.handInTest(() => {
                // After hand in, reload the activity so that results are shown
                Backbone.history.loadUrl()
            }),
            () => {},
            window.i18n.gettext('Hand in'),
        )
    }
</script>

{#if ACL.checkRole(ACL.roles.TEACHER) || (isStudentExamMode && isStart)}
    {#if isStart}
        <header>{window.i18n.gettext('This entry test is about the following sections')}:</header>
        <div class="sections">
            {#each getEntryTestSections(model) as section (section.id)}
                <ContentLabel
                    model={section}
                    isOnBackground={true}
                ></ContentLabel>
            {:else}
                {window.i18n.gettext('No sections have been selected')}
            {/each}
        </div>
        <header>{window.i18n.sprintf(
            window.i18n.ngettext('%d task group', '%d task groups', model.task_groups.length),
            model.task_groups.length
        )}</header>
        <Button
            label={window.i18n.gettext('Begin')}
            iconRight="arrow-right"
            size="medium"
            callback={() => navigationBar.toNextItem()}
        ></Button>
    {:else}
        <header>{window.i18n.sprintf(window.i18n.gettext('End of %s'), model.getActivityTypeLabel().toLowerCase())}</header>
        <header>{model.get('name')}</header>
        <Button
            label={window.i18n.gettext('Done')}
            icon="cross"
            size="medium"
            callback={gotoParentSection}
        ></Button>
    {/if}
{:else if isStudentExamMode && !isStart}
    {#if unfinishedTasks.length}
        <header>{window.i18n.sprintf(window.i18n.gettext('End of %s'), model.getActivityTypeLabel().toLowerCase())}</header>
        <header>{window.i18n.sprintf(window.i18n.ngettext(
            'You haven\'t answered %s task.',
            'You haven\'t answered %s tasks.',
            unfinishedTasks.length
        ), unfinishedTasks.length)}</header>
        <UnfinishedTasksCard
            {unfinishedTasks}
            activityModel={model}
            {navigationBar}
        ></UnfinishedTasksCard>
        <div class="actions">
            <Button
                label={window.i18n.gettext('Go back')}
                icon="restart"
                size="medium"
                callback={() => navigationBar.revertActiveItem()}
            ></Button>
            <Button
                label={window.i18n.gettext('Hand in incomplete')}
                icon="take-in"
                size="medium"
                theme="danger"
                callback={handInTest}
            ></Button>
        </div>
    {:else}
        <header>{window.i18n.sprintf(window.i18n.gettext('End of %s'), model.getActivityTypeLabel().toLowerCase())}</header>
        <header>{window.i18n.sprintf(window.i18n.gettext('Hand in this %s when you are finished'), model.getActivityTypeLabel().toLowerCase())}</header>
        <div class="actions">
            <Button
                label={window.i18n.gettext('Hand in')}
                icon="take-in"
                size="medium"
                theme="primary"
                callback={handInTest}
            ></Button>
        </div>
    {/if}
{:else if isStudentExamClosedMode}
    <header>{window.i18n.gettext('Attained section exemptions')}</header>
    <header>{model.get('name')}</header>
    <div class="entry-test-results">
        {#each getEntryTestSections(model) as section (section.id)}
            {const attainablePoints = getAttainableTestScoreForSection(model, section.id)}
            {const points = getScoreForSection(model, section.id)}
            {const hasAttainedExemption = model.get('entry_test')?.exempted_section_ids.includes(section.id)}
            <ContentLabel
                model={section}
                isOnBackground={true}
            ></ContentLabel>
            <span
                class="exemption-attained-label"
                class:exemption-attained-label--attained={hasAttainedExemption}
            >
                <span>
                    <Icon name="palm-tree"></Icon>
                </span>
                {#if hasAttainedExemption}
                    {window.i18n.gettext('Attained')}
                {:else}
                    {window.i18n.gettext('Not attained')}
                {/if}
            </span>
            <span class="points">
                {window.i18n.sprintf(window.i18n.ngettext(
                    '%s out of %s point',
                    '%s out of %s points',
                    attainablePoints,
                ), points.toLocaleString(undefined, {maximumFractionDigits: 1}), attainablePoints)}
            </span>
        {/each}
    </div>
    {#if isStudentReviewAnswersMode && isStart}
        <Button
            label={window.i18n.gettext('Review')}
            iconRight="arrow-right"
            size="medium"
            callback={() => navigationBar.toNextItem()}
        ></Button>
    {:else}
        <Button
            label={window.i18n.gettext('Done')}
            icon="cross"
            size="medium"
            callback={gotoParentSection}
        ></Button>
    {/if}
{/if}

<style lang="scss">/*
* Scut, a collection of Sass utilities
* to ease and improve our implementations of common style-code patterns.
* v1.0.1
* Docs at http://davidtheclark.github.io/scut
*/
/* TODO implement tooltip arrow */
header {
  font-size: 16px;
}
header + header {
  font-size: 26px;
  font-weight: 600;
}

.sections {
  display: grid;
  gap: 8px;
  min-width: 260px;
  background-color: rgba(0, 0, 0, 0.1);
  border-radius: 16px;
  padding: 16px;
}

.actions {
  display: flex;
  gap: 16px;
}

.entry-test-results {
  display: grid;
  grid-template-columns: 1fr 0.5fr 0.5fr;
  gap: 8px 16px;
  min-width: 480px;
  background-color: rgba(0, 0, 0, 0.1);
  border-radius: 16px;
  padding: 16px;
}

.exemption-attained-label {
  background-color: rgba(0, 0, 0, 0.5);
  border-radius: 32px;
  padding: 4px 12px 4px 4px;
  display: flex;
  align-items: center;
  gap: 8px;
  white-space: nowrap;
  width: fit-content;
}
.exemption-attained-label > span {
  border-radius: 100%;
  background-color: #9a9bb5;
  padding: 4px;
  width: 24px;
  height: 24px;
}
.exemption-attained-label > span :global(svg) {
  height: 16px;
  fill: #fff;
}
.exemption-attained-label--attained > span {
  background-color: #3fd17d;
}

.points {
  font-size: 14px;
  font-variant-caps: all-small-caps;
  letter-spacing: 1px;
  line-height: 12px;
  color: hsl(205, 60%, 44%);
  display: flex;
  align-items: center;
  white-space: nowrap;
}</style>
